import React from 'react';
import {
    Route, RouterProvider, createRoutesFromElements, Outlet,
} from 'react-router-dom';
import { createBrowserRouter } from '@datadog/browser-rum-react/react-router-v6';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { PUBLIC_URLS } from 'services/urls';
import DirectSignUpPage from 'views/public/SignUp/DirectSignUpPage/DirectSignUpPage';
import { SignUpProvider } from './views/public/SignUp/SignUpContext';
import SignUp from './views/public/SignUp/SignUp';
import NotFound from './views/public/NotFound/NotFound';
import { config } from './config';

const SignUpLayout: React.FC = () => (
    <SignUpProvider>
        <Outlet />
    </SignUpProvider>
);

const router = createBrowserRouter(
    createRoutesFromElements(
        <>
            <Route element={(<SignUpLayout />)}>
                <Route path={PUBLIC_URLS.SIGN_UP.LANDING_PAGE} element={<SignUp />} />
                <Route path={PUBLIC_URLS.SIGN_UP.DIRECT_SIGN_UP} element={<DirectSignUpPage />} />
            </Route>
            <Route path="*" element={<NotFound />} />
        </>,
    ),
    {
        future: {
            v7_relativeSplatPath: true,
        },
    },
);

const PublicAppRouter: React.FC = () => (
    <GoogleReCaptchaProvider reCaptchaKey={config.googleCaptchaApiKey}>
        <RouterProvider router={router} />
    </GoogleReCaptchaProvider>
);

export default PublicAppRouter;
